import { render, staticRenderFns } from "./CreateClassMenuExcel.vue?vue&type=template&id=66639946&scoped=true"
import script from "./CreateClassMenuExcel.vue?vue&type=script&lang=js"
export * from "./CreateClassMenuExcel.vue?vue&type=script&lang=js"
import style0 from "./CreateClassMenuExcel.vue?vue&type=style&index=0&id=66639946&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66639946",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66639946')) {
      api.createRecord('66639946', component.options)
    } else {
      api.reload('66639946', component.options)
    }
    module.hot.accept("./CreateClassMenuExcel.vue?vue&type=template&id=66639946&scoped=true", function () {
      api.rerender('66639946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/CreateClassMenuExcel.vue"
export default component.exports